import { Skeleton, Textarea, TextAreaProps } from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";
import { isMobileSafari } from "react-device-detect";
import { cn } from "@/utils";
import { isNativePlatform } from "@/utils/native";

type TextArea = MantineFormValues & TextAreaProps;

export const LimeTextarea = React.forwardRef(
  (
    { error, isLoading, ...props }: TextArea & { isLoading?: boolean },
    ref: React.Ref<HTMLTextAreaElement>,
  ) => (
    <Skeleton
      isLoaded={!isLoading}
      className={cn(props.className, "w-full rounded-xl")}
    >
      <Textarea
        ref={ref}
        errorMessage={error}
        isInvalid={!!error}
        {...props}
        classNames={{
          ...props.classNames,
          input: cn(props.classNames?.input, {
            "text-[16px]": isMobileSafari || isNativePlatform(),
          }),
        }}
      />
    </Skeleton>
  ),
);
LimeTextarea.displayName = "LimeTextarea";
